import type { IBrandColors } from '@wci-tech/core-ui';

export const lightBrandColors: IBrandColors = {
  primary: {
    default: '#4054D1',
    light: '#A7B0EA',
    lighter: '#C4CAF1',
    lightest: '#ECEEFA',
  },
  secondary: {
    default: '#17CECA',
    light: '#94E8E7',
    lighter: '#B7F0EF',
    lightest: '#E8FAFA',
  },
};

export const darkBrandColors: IBrandColors = {
  primary: {
    default: '#4054D1',
    light: '#A7B0EA',
    lighter: '#C4CAF1',
    lightest: '#ECEEFA',
    dark: '#3A4CBE',
    darker: '#2D3C94',
    darkest: '#1B2358',
  },
  secondary: {
    default: '#17CECA',
    light: '#94E8E7',
    lighter: '#B7F0EF',
    lightest: '#E8FAFA',
    dark: '#15BBB8',
    darker: '#10928F',
    darkest: '#0A5755',
  },
};
